import createNotification from 'store/factories/createNotification';
import fetch from 'cross-fetch';
import { actLoginTimedOut } from './loginStateActions';
import { ApiPrefix, statusCheck, json, getCookie } from '../util/icwUtility';

export const NOTIFICATION_ADD = 'NOTIFICATION_ADD';
export function actNotificationAdd(options) {
  return { type: NOTIFICATION_ADD, payload: createNotification(options) };
}

export const NOTIFICATION_REMOVE = 'NOTIFICATION_REMOVE';
export function actNotificationRemove(key) {
  return { type: NOTIFICATION_REMOVE, payload: key };
}

export const NOTIFICATION_FETCH_BEGIN = 'NOTIFICATION_FETCH_BEGIN';
export function actNotificationBegin() {
  return { type: NOTIFICATION_FETCH_BEGIN };
}

export const NOTIFICATION_FETCH_SUCCESS = 'NOTIFICATION_FETCH_SUCCESS';
export function actNotificationSuccess(data) {
  return { type: NOTIFICATION_FETCH_SUCCESS, data };
}

export const NOTIFICATION_FETCH_FAIL = 'NOTIFICATION_FETCH_FAIL';
export function actNotificationFail() {
  return { type: NOTIFICATION_FETCH_FAIL };
}

export function actNotificationFetch() {
  return (dispatch) => {
    dispatch(actNotificationBegin());
    return fetch(`${ApiPrefix}/notifications`, {
      method: 'GET',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then(statusCheck)
      .then(json)
      .then((json) => {
        if (json) {
          dispatch(actNotificationSuccess(json));
        } else {
          dispatch(actNotificationSuccess());
        }
      })
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }
        dispatch(actNotificationFail(typeof err === 'object' ? err.message : err));
      });
  };
}

export function actNotificationUpdate(obj) {
  return (dispatch) => {
    return fetch(`${ApiPrefix}/notifications`, {
      method: 'PATCH',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(obj),
    })
      .then(statusCheck)
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }
        dispatch(actNotificationFail(typeof err === 'object' ? err.message : err));
      });
  };
}
